export function filterSemantics<T, U extends { mediaTypeSemantics?: string[] }>(
  dataKey: keyof T,
  data?: T[],
  row?: U,
) {
  const upRow = { ...row }
  return data?.filter((d) =>
    upRow?.mediaTypeSemantics?.includes((d?.[dataKey] as any)?.toUpperCase()),
  )
}

export const mapBy =
  <T>(
    labelKey: keyof T,
    valueKey: keyof T,
    valueTransform: (v: string) => string = (v) => v,
    parentKey?: keyof T,
  ) =>
  (d: T) => ({
    name: d[labelKey] as unknown as string,
    value: valueTransform(d[valueKey] as unknown as string),
    parent: !!parentKey ? (d[parentKey] as unknown as string) : undefined,
  })
